import { useSortable } from '@dnd-kit/sortable';
import { IToken, TutorialStatusEnum } from 'views/types/token';
import { CSS } from '@dnd-kit/utilities';

export const TokenItem = ({ token, i }: { token: IToken; i: number }) => {
const isReserve = token.tutorialStatus === TutorialStatusEnum.RESERVE;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: token?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
  };

  const DragHandle = () => (
    <span {...attributes} {...listeners} style={{ cursor: 'grab' }}>
      ☰
    </span>
  );

  if (!token) return null;

  return (
    <div
      ref={setNodeRef}
      style={isReserve ? style : {}}
      className="flex bg-[#FFFFFF] flex-row gap-5 p-3 w-full border items-center rounded-md justify-between"
    >
      {isReserve ? <DragHandle /> : <div className='w-[10px]' />}
      <div className="flex items-center justify-center w-10">
        <p>{i + 1}</p>
      </div>

      <div className="flex flex-col gap-1 w-20">
        <p className="font-medium">Symbol:</p>
        <p>{token.name}</p>
      </div>

      <div className="flex flex-col gap-1 w-[420px]">
        <p className="font-medium">Contract Address:</p>
        <p>{token.contractAddress}</p>
      </div>

      <div className="flex flex-col gap-1">
        <p className="font-medium">Gift places:</p>
        <p>
          {token.bank.joinedUsersCount} / {token.bank.maxUsersAmount}
        </p>
      </div>
    </div>
  );
};
